import { IconType } from "react-icons";
import { FaCommentDots, FaCrosshairs, FaFilm } from "react-icons/fa";
import styled from "styled-components";
import { Box, Flex, Text } from "rebass/styled-components";

import { HOW, IStep, STEPS } from "../data";
import {
  ACCENT,
  ACCENT_BORDER,
  ACCENT_SOFT,
  Section,
  SectionHeading,
  Underlined,
} from "../../styledComponents";

// Ordered to match STEPS: make a play, call it, get the clip.
const STEP_ICONS: IconType[] = [FaCrosshairs, FaCommentDots, FaFilm];

export const HowItWorks = () => (
  <Section id="how" py={[72, 96, 120]}>
    <SectionHeading textAlign="center">
      {HOW.headingLead}
      <Underlined>{HOW.headingUnderlined}</Underlined>
    </SectionHeading>

    <Steps mt={[8, 9, 9]}>
      {STEPS.map((step: IStep, index: number) => {
        const Icon = STEP_ICONS[index];

        return (
          <Step key={step.title}>
            <IconTile>
              <Icon aria-hidden="true" />
              <StepIndex>{index + 1}</StepIndex>
            </IconTile>

            <Text color="ice" fontSize={[20, 21, 23]} fontWeight={700} mt={6}>
              {step.title}
            </Text>
            <Text
              color="chalk"
              fontSize={[16, 16.5, 17]}
              lineHeight={1.6}
              mt={3}
              maxWidth="34ch"
            >
              {step.description}
            </Text>
          </Step>
        );
      })}
    </Steps>
  </Section>
);

const Steps = styled(Box)`
  display: grid;
  gap: 48px 40px;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    gap: 44px;
    grid-template-columns: 1fr;
  }
`;

// Centred on desktop so the three read as one row of equals; left-aligned once
// they stack, where centred text in a single column just looks adrift.
const Step = styled(Flex)`
  align-items: center;
  flex-direction: column;
  min-width: 0;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    align-items: flex-start;
    text-align: left;
  }
`;

// The step number rides the corner of the icon rather than sitting in its own
// tile, so the sequence is legible without a second row of circles.
const IconTile = styled(Flex)`
  align-items: center;
  background: ${ACCENT_SOFT};
  border: 1px solid ${ACCENT_BORDER};
  border-radius: 18px;
  color: ${ACCENT};
  height: 76px;
  justify-content: center;
  position: relative;
  width: 76px;

  svg {
    height: 32px;
    width: 32px;
  }
`;

const StepIndex = styled.span`
  align-items: center;
  background: ${({ theme }) => theme.colors.darkerNed};
  border: 1px solid ${ACCENT_BORDER};
  border-radius: 50%;
  color: ${ACCENT};
  display: flex;
  font-size: 12px;
  font-style: italic;
  font-weight: 900;
  height: 26px;
  justify-content: center;
  position: absolute;
  right: -9px;
  top: -9px;
  width: 26px;
`;
